import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { xhrClinicalGetExamNoteByExamId } from "../utilities/xhr-clinical";
import translator from "../utilities/translator";
import { toastUtil } from "../utilities/toast-util";

function NotesComponent({
	mainExam,
	bundledExams
}) {
	const token = useSelector((state) => state.session.token);
	const currentLanguage = useSelector((state) => state.session?.userPreferences?.language);
	const userInfo = useSelector((state) => state.session.userInfo);
	const userPermissions = useSelector((state) => state.session.userPermissions);
	
	const [noteResult, setNotes] = React.useState();
	React.useEffect(() => {
		let mountedRef = true;
		if (mainExam?.id) {
			
		const effectPromise = async () => {
				var data = await xhrClinicalGetExamNoteByExamId(token, mainExam.id);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setNotes(data?.result?.data);

			}
			effectPromise();

		}
	}, [mainExam, token]);

	const [noteTec, setTechnicianNote] = React.useState('');
	const [noteMed, setDoctorNote] = React.useState('');
	const [noteTyp, setTypistNote] = React.useState('');
	const [noteTecRows, setTechnicianNoteRows] = React.useState(1);
	const [noteMedRows, setDoctorNoteRows] = React.useState(1);
	const [noteTypRows, setTypistNoteRows] = React.useState(1);

	React.useEffect(() => {
		setTechnicianNote(noteResult?.find((x) => x.type === 1)?.text || "");
		setDoctorNote(noteResult?.find((x) => x.type === 2)?.text || "");
		setTypistNote(noteResult?.find((x) => x.type === 3)?.text || "");
	}, [noteResult]);

	React.useEffect(() => {
		var noteRows = (((noteTec?.match(/\n/g) || [])?.length)+1)??1;
		setTechnicianNoteRows(noteRows < 6 ? noteRows : 6);
	}, [noteTec]);

	React.useEffect(() => {
		var noteRows = (((noteMed?.match(/\n/g) || [])?.length)+1)??1;
		setDoctorNoteRows(noteRows < 6 ? noteRows : 6);
	}, [noteMed]);

	React.useEffect(() => {
		var noteRows = (((noteTyp?.match(/\n/g) || [])?.length)+1)??1;
		setTypistNoteRows(noteRows < 6 ? noteRows : 6);
	}, [noteTyp]);
	


	return (
		<>
			<div className="form-group m-0">
				<div className="form-group" style={{ display: "flex" }}>
					<div style={{ width: "6em", whiteSpace: "break-spaces", textTransform: 'capitalize',	fontWeight: '500'}}>
						{`${translator(currentLanguage, 'technician')}:`}
					</div>
					<textarea
						className="form-control"
						value={noteTec}
						disabled={true}
						onChange={async (e) => {this.style.height = "";this.style.height = this.scrollHeight + 2 + "px"}}
						rows={noteTecRows}
					/>
				</div>
			</div>
			<div className="form-group m-0">
				<div className="form-group" style={{ display: "flex" }}>
					<div
						style={{
							width: "6em",
							whiteSpace: "break-spaces",
							textTransform: "capitalize", fontWeight: '500'
							
						}}
					>
						{`${translator(currentLanguage, 'doctor')}:`}
					</div>
				
					<textarea
					className="form-control"
					value={noteMed}
					disabled={true}
					onChange={async (e) => {this.style.height = "";this.style.height = this.scrollHeight + 2 + "px"}}
					rows={noteMedRows}
					/>
				</div>
			</div>
			<div className="form-group m-0">
				<div className="form-group" style={{ display: "flex" }}>
					<div style={{ width: "6em", whiteSpace: "break-spaces", 
					textTransform: 'capitalize',	fontWeight: '500' }}>
						{`${translator(currentLanguage, 'typist')}:`}
					</div>
					
						<textarea
						className="form-control"
						value={noteTyp}
						disabled={true}
						onChange={async (e) => {this.style.height = "";this.style.height = this.scrollHeight + 2 + "px"}}
						rows={noteTypRows}
						/>
				</div>
			</div>
		</>
	);
}

export default NotesComponent;
